// extracted by mini-css-extract-plugin
module.exports = {"GridImageText":"styles_GridImageText__3AenQ","title":"styles_title__2xG5B","itemsGrid":"styles_itemsGrid__3BSO5","box":"styles_box__LWMYn","isOdd":"styles_isOdd__wXO0w"};